import request from '@/utils/request'

/**
 * 获取用户信息（员工）
 */
export function getUserInfo(data) {
  return request({
    url: 'api/getUserInfo',
    method: 'post',
    params: data
  })
}

/**
 * 用户积分收支列表
 */
export function getUserIntegralList(data) {
  return request({
    url: 'api/getUserIntegralList',
    method: 'post',
    params: data
  })
}

/**
 * 获取用户学习列表
 */
export function getUserStudyList(data) {
  return request({
    url: 'api/getUserStudyList',
    method: 'post',
    params: data
  })
}

/**
 * 获取用户收藏列表
 */
export function getUserCollect(data) {
  return request({
    url: 'api/getUserCollect',
    method: 'post',
    params: data
  })
}

/**
 * 收藏和取消收藏
 */
export function collectNews(data) {
  return request({
    url: 'api/collectNews',
    method: 'post',
    params: data
  })
}

/**
 * 获取抽奖
 */
export function getLottery(data) {
  return request({
    url: 'api/getLottery',
    method: 'post',
    params: data
  })
}


/**
 * 获取抽奖奖项
 */
export function getLotteryItem(data) {
  return request({
    url: 'api/getLotteryItem',
    method: 'post',
    params: data
  })
}


/**
 * 商品列表
 */
export function getGoodsList(data) {
  return request({
    url: 'api/getGoodsList',
    method: 'post',
    params: data
  })
}


/**
 * 商品分类
 */
export function getGoodsClassify() {
  return request({
    url: 'api/getGoodsClassify',
    method: 'post'
  })
}
/**
 * 商品详情
 */
export function getGoodsDetail(data) {
  return request({
    url: 'api/getGoodsDetail',
    method: 'post',
    params: data
  })
}
/**
 * 用户购买操作
 */
export function buyGoods(data) {
  return request({
    url: 'api/buyGoods',
    method: 'post',
    params: data
  })
}
/**
 * 用户兑换记录
 */
export function userChangeList(data) {
  return request({
    url: 'api/userChangeList',
    method: 'post',
    params: data
  })
}







